module.exports = __webpack_public_path__ + "static/ecommerce1-a733293ddb3831042ee8fca2363abec7.jpg";